<template>
  <div id="mapObj">
    <Searchbar
      :mapObj="this.$props.mapObj"
      :hydranten="hydrantenController.alleHydranten"
      :sammelpunkte="sammelpunkteController.alleSammelpunkte"
      :rettungspunkte="rettungspunkteController.alleRettungspunkte"
      @kartenAuswahlActive="kartenAuswahlActive = $event"
      @locationFound="setView"
      />

    <KartenAuswahl
      :kartenAuswahlActive="kartenAuswahlActive"
      @kartenAuswahlActive="kartenAuswahlActive = $event"
      @switchHydrantenVisibility="switchHydrantenVisibility()"
      @switchLeitungenVisibility="switchLeitungenVisibility()"
      @switchSammelpunkteVisibility="switchSammelpunkteVisibility()"
      @switchRettungspunkteVisibility="switchRettungspunkteVisibility()"
      :hydrantenVisible="hydrantenVisible"
      :leitungenVisible="leitungenVisible"
      :sammelpunkteVisible="sammelpunkteVisible"
      :rettungspunkteVisible="rettungspunkteVisible"
      />
    <l-map
      id="mapId"
      ref="map"
      v-model:zoom="zoom"
      :center="[this.centerLat, this.centerLng]"
      @ready="onMapReady"
      @moveend="onMapMoveEnd"
      @click="mapClick"
    >

      <!-- Marker -->
      <span id="feuerwachen">
        <Feuerwache
          :markerPosition="[lat, lng]"
          :bezeichnung="feuerwehr.name"
          :zoom="zoom"
          :aktiveFeuerwehr="true"
        />
        <Feuerwache
          v-for="partner in partnerFeuerwehren"
          :key="partner.feuerwehrID"
          :markerPosition="[partner.positionX, partner.positionY]"
          :bezeichnung="partner.name"
          :zoom="zoom"
          :aktiveFeuerwehr="false"
        />
      </span>

      <span id="hydranten" v-if="this.hydrantenVisible && this.zoom > 15 && this.hydrantenLesen">
        <Hydrant
          v-for="hydrant in hydrantenController.aktiveHydranten"
          :key="hydrant.wasserquellenID"
          :markerPosition="[hydrant.position.x,hydrant.position.y]"
          :hydrantObj="hydrant"
          :zoom="zoom"
          :tooltips="this.hydrantenTooltips"
          :hydrantenBearbeiten="hydrantenBearbeitenBoolean"
          :hydrantenEntfernen="hydrantenEntfernenBoolean"
          @hydrantBearbeiten="hydrantBearbeiten"
          @hydrantEntfernen="hydrantEntfernen"
        />
      </span>

      <span id="leitungen" v-if="this.leitungenVisible && this.zoom > 16 && this.leitungenLesen">
        <span v-for="leitung in leitungenController.aktiveLeitungen" :key="leitung.leitungsID">
          <Leitung
            :url="activeURL"
            :leitungsObj="leitung"
            :leitungenController="leitungenController"
            :leitungenHinzufuegenBoolean="leitungenHinzufuegenBoolean"
            :leitungenEntfernenBoolean="leitungenEntfernenBoolean"
            :tooltips="this.leitungenTooltips"
            :farbigeLeitungen="this.colorMode"
            @addLeitungsposition="addLeitungsposition"
            @removeLeitungsposition="removeLeitungsposition"
          />
        </span>
      </span>

      <span id="sammelpunkte" v-if="this.sammelpunkteVisible && this.zoom > 15 && this.sammelstationenLesen">
        <Sammelpunkt
          v-for="sammelpunkt in sammelpunkteController.aktiveSammelpunkte"
          :key="sammelpunkt.id"
          :markerPosition="[sammelpunkt.position.x,sammelpunkt.position.y]"
          :sammelpunktObj="sammelpunkt"
          :zoom="zoom"
          :tooltips="this.sammelpunkteTooltips"
          :sammelpunkteBearbeiten="sammelpunkteBearbeitenBoolean"
          :sammelpunkteEntfernen="sammelpunkteEntfernenBoolean"
          @sammelpunktBearbeiten="sammelpunktBearbeiten"
          @sammelpunktEntfernen="sammelpunktEntfernen"
        />
      </span>

      <span id="rettungspunkte" v-if="this.rettungspunkteVisible && this.zoom > 11">
        <Rettungspunkt
          v-for="rettungspunkt in rettungspunkteController.aktiveRettungspunkte"
          :key="rettungspunkt.id"
          :markerPosition="[rettungspunkt.position.y,rettungspunkt.position.x]"
          :rettungspunktObj="rettungspunkt"
          :zoom="zoom"
          :tooltips="this.rettungspunkteTooltips"
        />
      </span>

      <Position v-if="this.positionVisible" @positionUpdate="setView" @setPositionActive="setGPSActive"/>
    </l-map>

    <!-- Bearbeitungsoptionen -->
    <button v-if="(this.hydrantenBearbeiten || this.leitungenBearbeiten || this.sammelstationenBearbeiten)" id="bearbeitungsButton"
      @click="this.bearbeitungsmodusAktiv = !this.bearbeitungsmodusAktiv" class="fa">&#xf044;</button>
    <span id="bearbeitungsControl" v-if="bearbeitungsmodusAktiv">
      <button v-if="this.hydrantenBearbeiten && this.hydrantenVisible" :class="hydrantenHinzufuegenBoolean ? 'buttonOn' : 'buttonOff'"
        @click="switchhydrantenHinzufuegenBooleanVisibility(this.hydrantenHinzufuegenBoolean)">Hydranten hinzufügen</button>
      <button v-if="this.hydrantenBearbeiten && this.hydrantenVisible" :class="hydrantenBearbeitenBoolean ? 'buttonOn' : 'buttonOff'"
        @click="switchhydrantenBearbeitenBooleanVisibility(this.hydrantenBearbeitenBoolean)">Hydranten bearbeiten</button>
      <button v-if="this.hydrantenBearbeiten && this.hydrantenVisible" :class="hydrantenEntfernenBoolean ? 'buttonOn' : 'buttonOff'"
        @click="switchhydrantenEntfernenBooleanVisibility(this.hydrantenEntfernenBoolean)">Hydranten entfernen</button>
      <button v-if="this.leitungenBearbeiten && this.leitungenVisible" :class="ringleitungHinzufuegenBoolean ? 'buttonOn' : 'buttonOff'"
        @click="switchringleitungHinzufuegenBooleanVisibility(this.ringleitungHinzufuegenBoolean)">Ringleitung hinzufügen</button>
      <button v-if="this.leitungenBearbeiten && this.leitungenVisible" :class="leitungenHinzufuegenBoolean ? 'buttonOn' : 'buttonOff'"
        @click="switchleitungenHinzufuegenBooleanVisibility(this.leitungenHinzufuegenBoolean)">Leitungen hinzufügen</button>
      <button v-if="this.leitungenBearbeiten && this.leitungenVisible" :class="leitungenEntfernenBoolean ? 'buttonOn' : 'buttonOff'"
        @click="switchleitungenEntfernenBooleanVisibility(this.leitungenEntfernenBoolean)">Leitungen entfernen</button>

      <button v-if="this.sammelstationenBearbeiten && this.sammelpunkteVisible" :class="sammelpunkteHinzufuegenBoolean ? 'buttonOn': 'buttonOff'"
        @click="switchsammelpunkteHinzufuegenBooleanVisibility(this.sammelpunkteHinzufuegenBoolean)">Sammelpunkte hinzufügen</button>
      <button v-if="this.sammelstationenBearbeiten && this.sammelpunkteVisible" :class="sammelpunkteBearbeitenBoolean ? 'buttonOn': 'buttonOff'"
        @click="switchsammelpunkteBearbeitenBooleanVisibility(this.sammelpunkteBearbeitenBoolean)">Sammelpunkte bearbeiten</button>
      <button v-if="this.sammelstationenBearbeiten && this.sammelpunkteVisible" :class="sammelpunkteEntfernenBoolean ? 'buttonOn': 'buttonOff'"
        @click="switchsammelpunkteEntfernenBooleanVisibility(this.sammelpunkteEntfernenBoolean)">Sammelpunkte entfernen</button>
    </span>

    <!-- Offline Button -->
    <!--<button class="offline-btn" @click="showOfflinePopup = true">
      Offline Karten speichern
    </button>

    <div v-if="showOfflinePopup" class="popup">
      <h3>Offline Karten herunterladen</h3>

      <label>Radius: {{ offlineRadius }} m</label>
      <input type="range" min="100" max="5000" step="100" v-model="offlineRadius" />

      <button @click="startOfflineDownload">Download starten</button>
      <button @click="showOfflinePopup = false">Abbrechen</button>
    </div>-->

    <span @click="this.leitungsAgendaVisible = false, this.leitungsAgendaAusgeklappt = false" id="leitungsAgenda"
      v-show="(this.colorMode && this.leitungenVisible && this.leitungsAgendaVisible && this.leitungsAgendaAusgeklappt && this.$props.mapObj == 'hydrant')">
      <p><span id="rot"></span>80 - 99</p>
      <p><span id="orange"></span>100 - 124</p>
      <p><span id="gelb"></span>125 - 149</p>
      <p><span id="gruen"></span>150 - 199</p>
      <p><span id="blau"></span>größer 200</p>
    </span>

    <div id="mapControlls">
      <button id="hydrantenButton" class="mapButton" :class="{ buttonFirstPosition: !settingsVisible, hydrantenButton: settingsVisible, buttonActive: hydrantenVisible }" @click="switchHydrantenVisibility()"><img src="@/assets/Icons/Hydrant.svg"></button>
      <router-link :to="`/einsatz/`+this.$route.params.id"><button id="homeButton" class="mapButton"><img src="@/assets/Icons/HomeButton.svg"></button></router-link>
      <button id="leitungenButton" class="mapButton" :class="{ buttonFirstPosition: !settingsVisible, leitungenButton: settingsVisible, buttonActive: leitungenVisible }" @click="switchLeitungenVisibility()"><img src="@/assets/KartenIcons/Leitung.png"></button>

      <button id="gps" @click="this.positionVisible = !this.positionVisible" class="mapButton" :class="{ buttonFirstPosition: !settingsVisible, gps: settingsVisible, buttonError: !positionShown, buttonSuccess: positionShown }"><img src="@/assets/KartenIcons/gps.png"></button>
      <button id="buttonAgenda" v-if="this.colorMode && !this.leitungsAgendaAusgeklappt && this.leitungenVisible" @click="this.leitungsAgendaVisible = true; this.leitungsAgendaAusgeklappt = true" class="mapButton"><img src="@/assets/KartenIcons/info.png"></button>
      <button id="settingsButton" @click="this.settingsVisible = !this.settingsVisible" class="mapButton"><img src="@/assets/KartenIcons/setting.png" class="settings" :class="{ buttonFirstPosition: !settingsVisible, settingsButton: settingsVisible }"></button>
      <button id="buttonLayer" @click="switchLayer()" class="mapButton" :class="{ buttonFirstPosition: !settingsVisible, buttonLayer: settingsVisible }"><img src="@/assets/KartenIcons/layers.png"></button>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

import { Feuerwehr } from "@/backend_controller/feuerwehr";
import { Partnerschaft } from "@/backend_controller/partnerschaft";
import { HydrantenController } from "@/components/Karten/Controller/hydranten";
import { LeitungenController } from "@/components/Karten/Controller/leitungen";
import { SammelpunkteController } from "@/components/Karten/Controller/sammelpunkte";
import { RettungspunkteController } from "./Karten/Controller/rettungspunkte";
import { Berechtigung } from "@/backend_controller/berechtigung";

import { LMap } from "@vue-leaflet/vue-leaflet";
import 'leaflet.vectorgrid/dist/Leaflet.VectorGrid.bundled.js';
import "leaflet.vectorgrid";

import Feuerwache from "@/components/Karten/Marker/Feuerwache.vue";
import Hydrant from "@/components/Karten/Marker/Hydrant.vue";
import Leitung from "@/components/Karten/Marker/Leitung.vue";
import Sammelpunkt from "@/components/Karten/Marker/Sammelpunkt.vue";
import Position from "@/components/Karten/Marker/Position.vue";

import OfflineTileManager from "@/offlineTiles";
import * as L from "leaflet";
import Searchbar from "./Karten/Searchbar.vue";
import KartenAuswahl from "./Karten/KartenAuswahl.vue";
import Rettungspunkt from "./Karten/Marker/Rettungspunkt.vue";

export default {
  name: "mapObjNeu",
  components: { LMap, Feuerwache, Hydrant, Leitung, Sammelpunkt, Rettungspunkt, Searchbar, KartenAuswahl, Position },
  props: {
    mapObj: String,
    berechtigungen: Array
  },

  data() {
    return {
      settingsVisible: false,
      leitungsAgendaVisible: false,
      zoom: 18,
      lat: 50.103988,
      lng: 10.143108,

      centerLat: 50.103988,
      centerLng: 10.143108,
      kartenAuswahlActive: false,

      feuerwehr: { name: "" },
      partnerFeuerwehren: [],
      hydrantenController: {},
      leitungenController: {},
      sammelpunkteController: {},
      rettungspunkteController: {},
      aktiveLeitungen: [],

      activeURL: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      baseMaps: [
        {
          name: 'Straße',
          url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        },
        {
          name: 'Satelit',
          url: "https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
        },
      ],
      aktiveMapName: 'Straße',

      showOfflinePopup: false,
      offlineRadius: 500,
      offlineManager: null,

      hydrantenVisible: false,
      leitungenVisible: false,
      leitungsAgendaVisible: true,
      leitungsAgendaAusgeklappt: false,
      sammelpunkteVisible: false,
      rettungspunkteVisible: false,

      positionVisible: false,
      positionShown: false,
      colorMode: true,

      // Bearbeitungsmodis
      bearbeitungsmodusAktiv: false,

      hydrantenBearbeiten: false,
      leitungenBearbeiten: false,
      hydrantenLesen: false,
      leitungenLesen: false,
      sammelstationenLesen: false,
      sammelstationenBearbeiten: false,

      hydrantenHinzufuegenBoolean: false,
      hydrantenBearbeitenBoolean: false,
      hydrantenEntfernenBoolean: false,
      ringleitungHinzufuegenBoolean: false,
      leitungenHinzufuegenBoolean: false,
      leitungenEntfernenBoolean: false,
      sammelpunkteHinzufuegenBoolean: false,
      sammelpunkteBearbeitenBoolean: false,
      sammelpunkteEntfernenBoolean: false,

      aktuelleLeitungsposition: null,
      aktuelleLeitungObjekt: null,

      hydrantenTooltips: false,
      leitungenTooltips: false,
      rettungspunkteTooltips: false,
      sammelpunkteTooltips: false
    };
  },

  methods: {
    setGPSActive(boolean){
      this.positionShown = boolean;
    },
    switchLayer(){
      let index = this.baseMaps.findIndex(m => m.name == this.aktiveMapName);
      if(index < this.baseMaps.length - 1){
        index++;
      } else{
        index = 0;
      }
      this.aktiveMapName = this.baseMaps[index].name;
      this.activeURL = this.baseMaps[index].url;
      if(this.customLayerInstance){
        this.customLayerInstance.setUrl(this.activeURL);
      }
    },
    async removeLeitungsposition(object){
      await this.leitungenController.removeLeitungsposition(object.position);
      this.aktuelleLeitungsposition = null;
      object.obj.refreshLeitungspositionen();
    },
    addLeitungsposition(object){
      this.aktuelleLeitungsposition = object.position;
      this.aktuelleLeitungObjekt = object.obj;
    },
    sammelpunktBearbeiten(sammelpunktObj){
      this.sammelpunkteController.editSammelpunkt(sammelpunktObj);
    },
    sammelpunktEntfernen(sammelpunktObj){
      this.sammelpunkteController.deleteSammelpunkt(sammelpunktObj.id)
    },
    hydrantBearbeiten(hydrantObj){
      this.hydrantenController.editHydrant(hydrantObj);
    },
    hydrantEntfernen(hydrantObj){
      this.hydrantenController.deleteHydrant(hydrantObj.wasserquellenID);
    },
    switchhydrantenHinzufuegenBooleanVisibility(hydrantenHinzufuegenBoolean){
      this.clearBearbeitungsmodus();
      this.hydrantenHinzufuegenBoolean = !hydrantenHinzufuegenBoolean;
    },
    switchhydrantenBearbeitenBooleanVisibility(hydrantenBearbeitenBoolean){
      this.clearBearbeitungsmodus();
      this.hydrantenBearbeitenBoolean = !hydrantenBearbeitenBoolean;
    },
    switchhydrantenEntfernenBooleanVisibility(hydrantenEntfernenBoolean){
      this.clearBearbeitungsmodus();
      this.hydrantenEntfernenBoolean = !hydrantenEntfernenBoolean;
    },
    switchringleitungHinzufuegenBooleanVisibility(ringleitungHinzufuegenBoolean){
      this.clearBearbeitungsmodus();
      this.ringleitungHinzufuegenBoolean = !ringleitungHinzufuegenBoolean;
    },
    switchleitungenHinzufuegenBooleanVisibility(leitungenHinzufuegenBoolean){
      this.clearBearbeitungsmodus();
      this.leitungenHinzufuegenBoolean = !leitungenHinzufuegenBoolean;
    },
    switchleitungenEntfernenBooleanVisibility(leitungenEntfernenBoolean){
      this.clearBearbeitungsmodus();
      this.leitungenEntfernenBoolean = !leitungenEntfernenBoolean;
    },
    switchsammelpunkteHinzufuegenBooleanVisibility(sammelpunkteHinzufuegenBoolean){
      this.clearBearbeitungsmodus();
      this.sammelpunkteHinzufuegenBoolean = !sammelpunkteHinzufuegenBoolean;
    },
    switchsammelpunkteBearbeitenBooleanVisibility(sammelpunkteBearbeitenBoolean){
      this.clearBearbeitungsmodus();
      this.sammelpunkteBearbeitenBoolean = !sammelpunkteBearbeitenBoolean;
    },
    switchsammelpunkteEntfernenBooleanVisibility(sammelpunkteEntfernenBoolean){
      this.clearBearbeitungsmodus();
      this.sammelpunkteEntfernenBoolean = !sammelpunkteEntfernenBoolean;
    },
    clearBearbeitungsmodus() {
      this.hydrantenHinzufuegenBoolean = false;
      this.hydrantenBearbeitenBoolean = false;
      this.hydrantenEntfernenBoolean = false;
      this.ringleitungHinzufuegenBoolean = false;
      this.leitungenHinzufuegenBoolean = false;
      this.leitungenEntfernenBoolean = false;
      this.sammelpunkteHinzufuegenBoolean = false;
      this.sammelpunkteBearbeitenBoolean = false;
      this.sammelpunkteEntfernenBoolean = false;
    },
    async setBearbeitungsberechtigung() {
      let response;
      if(this.$props.berechtigungen.length == 0){
        response = await Berechtigung.get(this.$route.params.id.replace(":", ""));
      } else{
        response = this.$props.berechtigungen;
      }
      if(response == false){
        return;
      } else{
        this.hydrantenBearbeiten = response.find(b => b.name == 'hydranten_bearbeiten') ? true : false;
        this.leitungenBearbeiten = response.find(b => b.name == 'leitungen_bearbeiten') ? true : false;
        this.leitungenLesen = response.find(b => b.name == 'leitungen_lesen') ? true : false;
        this.hydrantenLesen = response.find(b => b.name == 'hydranten_lesen') ? true : false;
        this.sammelstationenLesen = response.find(b => b.name == 'sammelstationen_lesen') ? true : false;
        this.sammelstationenBearbeiten = response.find(b => b.name == 'sammelstationen_bearbeiten') ? true : false;
      }
    },
    async initFeuerwehrData() {
      this.setVisibilityByMapObj();

      const response = await Feuerwehr.getFeuerwehrByKonvKey(
        this.$route.params.id.replace(":", "")
      );
      this.feuerwehr = response || JSON.parse(localStorage.getItem("AktiveFeuerwehr"));

      console.log(this.feuerwehr)
      this.lat = Number(this.feuerwehr.positionX) || 50.103988;
      this.lng = Number(this.feuerwehr.positionY) || 10.143108;

      this.setView({lat: this.lat, lng: this.lng});

      const partners = await Partnerschaft.getPartnerfeuerwehren(this.feuerwehr.feuerwehrID);
      this.partnerFeuerwehren = partners || JSON.parse(localStorage.getItem("PartnerFeuerwehren"));

      this.offlineManager = new OfflineTileManager( this.lat, this.lng, this.offlineRadius, this.activeURL );
    },

    async setVisibilityByMapObj() {
      if(this.$props.mapObj == "hydrant"){
        if(localStorage.getItem("HydrantenSichtbar")==1?true:false){
          this.hydrantenVisible = true;
        } else{
          this.hydrantenVisible = false;
        }
        if(localStorage.getItem("LeitungenSichtbar")==1?true:false){
          this.leitungenVisible = true;
        } else{
          this.leitungenVisible = false;
        }
        if(localStorage.getItem("RettungspunkteSichtbar")==1?true:false){
          this.rettungspunkteVisible = true;
        } else{
          this.rettungspunkteVisible = false;
        }
      } else if(this.$props.mapObj == "hiw"){
        this.rettungspunkteVisible = true;
      } else if(this.$props.mapObj == "sammelpunkte"){
        this.sammelpunkteVisible = true;
      } else {

      }
    },
    async switchHydrantenVisibility() {
      if(!this.hydrantenLesen){
        Swal.fire(
          "Keine Berechtigung", 
          "Sie haben keine Berechtigung, um Hydranten zu sehen.",
          "error")
        return;
      }
      this.hydrantenVisible = !this.hydrantenVisible;
      if(!this.hydrantenController || Object.keys(this.hydrantenController).length === 0){
        await this.initHydranten();
      }
    },
    async switchLeitungenVisibility() {
      if(!this.leitungenLesen){
        Swal.fire(
          "Keine Berechtigung", 
          "Sie haben keine Berechtigung, um Leitungen zu sehen.",
          "error")
        return;
      }
      this.leitungenVisible = !this.leitungenVisible;
      if(!this.leitungenController || Object.keys(this.leitungenController).length === 0){
        await this.initLeitungen();
      }
    },
    async switchSammelpunkteVisibility() {
      if(!this.sammelstationenLesen){
        Swal.fire(
          "Keine Berechtigung", 
          "Sie haben keine Berechtigung, um Sammelpunkte zu sehen.",
          "error")
        return;
      }
      this.sammelpunkteVisible = !this.sammelpunkteVisible;
      if(!this.sammelpunkteController || Object.keys(this.sammelpunkteController).length === 0){
        await this.initSammelpunkte();
      }
    },
    async switchRettungspunkteVisibility() {
      this.rettungspunkteVisible = !this.rettungspunkteVisible;
      if(!this.rettungspunkteController || Object.keys(this.rettungspunkteController).length === 0){
        await this.initRettungspunkte();
      }
    },
    async initHydranten() {
      this.hydrantenTooltips = localStorage.getItem("HydrantenTooltips")==1?true:false;
      this.hydrantenController = new HydrantenController(
        this.$route.params.id.replace(":", ""),
        this.$refs.map,
        this.feuerwehr.feuerwehrID,
        this.partnerFeuerwehren
      );
      await this.hydrantenController.init(localStorage.getItem("aenderungszeitpunktHydrant"));
      this.hydrantenController.getHydrantenInBounds(this.bounds);
    },
    async initLeitungen() {
      this.colorMode = localStorage.getItem("FarbigeLeitungen")==1?true:false;
      this.leitungsAgendaAusgeklappt = localStorage.getItem("AusgeklappteAgenda")==1?true:false;
      this.leitungenTooltips = localStorage.getItem("LeitungenTooltips")==1?true:false;
      this.leitungenController = new LeitungenController(
        this.$route.params.id.replace(":", ""),
        this.$refs.map,
        this.feuerwehr.feuerwehrID,
        this.partnerFeuerwehren
      );
      await this.leitungenController.init(localStorage.getItem("aenderungszeitpunktLeitung"));
      this.leitungenController.getLeitungspositionenInBounds(this.bounds);

      this.aktiveLeitungen = this.leitungenController.aktiveLeitungen;
    },
    async initSammelpunkte() {
      this.sammelpunkteTooltips = localStorage.getItem("SammelpunkteTooltips")==1?true:false;
      this.sammelpunkteController = new SammelpunkteController(
        this.$route.params.id.replace(":", ""),
        this.$refs.map,
        this.feuerwehr.feuerwehrID,
        this.partnerFeuerwehren
      );
      await this.sammelpunkteController.init(localStorage.getItem("aenderungszeitpunktSammelpunkt"));
      this.sammelpunkteController.getSammelpunkteInBounds(this.bounds);
    },
    async initRettungspunkte() {
      this.rettungspunkteTooltips = localStorage.getItem("RettungspunkteTooltips")==1?true:false;
      this.rettungspunkteController = new RettungspunkteController(
        this.$route.params.id.replace(":", ""),
        this.$refs.map,
        this.feuerwehr.feuerwehrID,
        this.partnerFeuerwehren
      );
      await this.rettungspunkteController.init(localStorage.getItem("aenderungszeitpunktRettungspunkt"));
      this.rettungspunkteController.getRettungspunkteInBounds(this.bounds);
    },

    async onMapReady() {
      await this.initFeuerwehrData();

      const mapRef = this.$refs.map;

      this.bounds = mapRef.leafletObject.getBounds();

      // Hydranten + Leitungen initialisieren
      if(this.hydrantenVisible){
        this.initHydranten();
      }
      if(this.leitungenVisible){
        this.initLeitungen();
      }
      if(this.sammelpunkteVisible){
        this.initSammelpunkte();
      }
      if(this.rettungspunkteVisible){
        this.initRettungspunkte();
      }

      this.positionVisible = true;

      this.setBearbeitungsberechtigung();

      // ⭐ Custom TileLayer manuell einfügen
      const CustomLayer = L.TileLayer.extend({
        createTile: (coords, done) => {
          const tile = document.createElement("img");

          this.loadTileOfflineOrOnline(coords.z, coords.x, coords.y, (err, src) => {
            tile.src = src;
            done(err, tile);
          });

          return tile;
        }
      });

      this.customLayerInstance = new CustomLayer(this.activeURL, {
        tileSize: 256,
        maxZoom: 19
      });

      this.customLayerInstance.addTo(mapRef.leafletObject);
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.map.leafletObject.invalidateSize();
        }, 100);
      });

      /*
      const url = "https://feuerwehr-server.org/tiles/maps/osm/{z}/{x}/{y}.pbf"; // Deine PBF-URL
      const vectorTileLayer = L.vectorGrid.protobuf(
        "https://feuerwehr-server.org/tiles/maps/osm/{z}/{x}/{y}.pbf",
        {
          rendererFactory: L.canvas.tile,   // canvas besser für Performance
vectorTileLayerStyles: {
  buildings: {
    weight: 1,
    color: "#666",
    fill: true,
    fillColor: "#ccc",
    fillOpacity: 0.5
  },
  lines: {
    weight: 1,
    color: "#000",
    fill: false
  },
  polygons: {
    weight: 1,
    color: "#666",
    fill: true,
    fillColor: "#ccc",
    fillOpacity: 0.5
  },
  points: {
    radius: 4,
    fill: true,
    fillColor: "#f00",
    color: "#900",
    weight: 1
  }
},
          interactive: false,
          maxZoom: 19,
          attribution: "© OpenStreetMap contributors"
        }
      );

      // Layer auf der Map hinzufügen
      vectorTileLayer.addTo(mapRef.leafletObject);
      this.customLayerInstance = vectorTileLayer;
      */
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.map.leafletObject.invalidateSize();
        }, 100);
      });
    },

    onMapMoveEnd() {
      const mapRef = this.$refs.map;
      const newBounds = mapRef.leafletObject.getBounds();

      if(this.hydrantenVisible){
        try{
          this.hydrantenController.getHydrantenInBounds(newBounds);
        } catch (error){
          console.error("Fehler beim Laden der Hydranten: ", error);
        }
      }
      if(this.leitungenVisible){
        try{
          this.leitungenController.getLeitungspositionenInBounds(newBounds);
        } catch (error){
          console.error("Fehler beim Laden der Leitungen: ", error);
        }
      }
      if(this.sammelpunkteVisible){
        try{
          this.sammelpunkteController.getSammelpunkteInBounds(newBounds);
        } catch (error){
          console.error("Fehler beim Laden der Sammelpunkte: ", error);
        }
      }
      if(this.rettungspunkteVisible){
        try{
          this.rettungspunkteController.getRettungspunkteInBounds(newBounds);
        } catch (error){
          console.error("Fehler beim Laden der Rettungspunkte: ", error);
        }
      }
      this.aktiveLeitungen = this.leitungenController.aktiveLeitungen;
    },

    async mapClick(event) {
      switch(true){
        case this.hydrantenHinzufuegenBoolean:
          this.hydrantenController.addHydrant(event.latlng.lat, event.latlng.lng);
          break;
        case this.ringleitungHinzufuegenBoolean:
          this.leitungenController.createRingleitung(event.latlng);
          break;
        case this.leitungenHinzufuegenBoolean:
          if(this.aktuelleLeitungsposition == null){
            Swal.fire({
              icon: 'error',
              title: 'Keine Leitungsposition ausgewählt',
              text: 'Bitte wählen Sie zuerst eine Leitungsposition aus, bevor Sie eine neue Leitung hinzufügen.',
            });
            return;
          }

          await this.leitungenController.addLeitungsposition(event.latlng, this.aktuelleLeitungsposition);
          this.aktuelleLeitungsposition = null;
          this.aktuelleLeitungObjekt.refreshLeitungspositionen();
          break;
        case this.sammelpunkteHinzufuegenBoolean:
          this.sammelpunkteController.addSammelpunkt(event.latlng.lat, event.latlng.lng);
          break;
      }
    },

    async startOfflineDownload() {
      console.log("[OfflineTiles] startOfflineDownload() aufgerufen");

      const online = await this.offlineManager.isOnline();
      if (!online) {
        alert("Kein Internet verfügbar!");
        return;
      }

      alert("Download gestartet...");
      await this.offlineManager.downloadTiles();
      alert("Download abgeschlossen!");
      this.showOfflinePopup = false;
    },

    async loadTileOfflineOrOnline(z, x, y, callback) {
      let offlineTile = null;

      if (this.offlineManager) {
        offlineTile = await this.offlineManager.getOfflineTile(z, x, y);
      }

      if (offlineTile) {
        callback(null, offlineTile);
      } else {
        const url = this.activeURL
          .replace("{z}", z)
          .replace("{x}", x)
          .replace("{y}", y);

        callback(null, url);
      }
    },
    setView({ lat, lng }) {
      const mapRef = this.$refs.map;
      mapRef.leafletObject.setView([lat, lng], 18);
      this.centerLat = lat;
      this.centerLng = lng;
    },
  }
};
</script>

<style lang="scss" scoped>
.offline-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 2000;
  padding: 10px;
  background: white;
  border: 1px solid #aaa;
}

.popup {
  position: absolute;
  top: 80px;
  left: 20px;
  z-index: 2000;
  background: white;
  padding: 20px;
  border: 1px solid #aaa;
}

#mapObj {
  width: 100vw;
  height: 100vh;
}

.buttonFirstPosition{
  transform: translateY(0rem);
  transform: rotate(0);
}

#buttonAgenda{
    position: absolute;
    bottom: 2.7rem;
    left: 1rem;
}

#buttonLayer{
  bottom: 3.05rem;
  right: 1.4rem;
  position: absolute;
  z-index: 429;
  width: 2.7rem;
  height: 2.7rem;
}

.buttonLayer{
  transform: translateY(-3.7rem);
}

#settingsButton{
  position: absolute;
  bottom: 2.7rem;
  right: 1rem;
  z-index: 430;
}

.settingsButton{
  transform: rotate(180deg);
}

.settings{
  transition: transform 0.3s ease;
}

#gps{
    position: absolute;
    bottom: 3.05rem;
    right: 1.4rem;
    z-index: 428;
    width: 2.7rem;
    height: 2.7rem;
}

.gps{
  transform: translateY(-7.2rem);
}

#leitungenButton{
    position: absolute;
    bottom: 3.05rem;
    right: 1.4rem;
    z-index: 427;
    width: 2.7rem;
    height: 2.7rem;
}

.leitungenButton{
  transform: translateY(-10.7rem);
}

#homeButton{
    position: absolute;
    bottom: 2.7rem;
    left: 50%;
    transform: translateX(-50%);
}

#hydrantenButton{
    position: absolute;
    bottom: 3.05rem;
    right: 1.4rem;
    z-index: 426;
    width: 2.7rem;
    height: 2.7rem;
}

.hydrantenButton{
  transform: translateY(-14.2rem);
}

.buttonActive{
    border: solid 1px blue;
    box-shadow: 0 0 2px 2px rgba(0, 17, 255, 0.87) !important;
}

.buttonError{
    border: solid 1px rgb(255, 0, 0);
    box-shadow: 0 0 2px 2px rgba(255, 0, 0, 0.87) !important;
}

.buttonSuccess{
  border: solid 1px rgb(0, 201, 0);
  box-shadow: 0 0 2px 2px rgba(0, 201, 0, 0.87) !important;
}

.mapButton{
    width: 3.5rem;
    height: 3.5rem;
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.11);
    background-color: white;
    z-index: 400;
    border: none;
    border-radius: 90px;
    transition: transform 0.3s ease;

    img{
        height: 60%;
        margin: auto;
    }
}

#leitungsAgendaButton {
  background-color: white !important;
  position: absolute !important;
  bottom: 0.5rem !important;
  left: 0.5rem !important;
  z-index: 1000 !important;
  padding: 0.5rem !important;
  border-radius: 7px !important;
}

#leitungsAgenda {
  background-color: white !important;
  position: absolute !important;
  bottom: 2.7rem !important;
  left: 0.5rem !important;
  z-index: 450 !important;
  padding: 1rem !important;
  border-radius: 7px !important;
  border: solid grey 1px;

  :hover {
    cursor: pointer;
  }

  p {
    display: flex;
    /* Flexbox verwenden */
    align-items: center;
    /* Zentrieren Sie die Elemente vertikal */
    padding: 2px 3px;
    /* Anpassung der Padding-Werte */
    margin: 3px 0;
    /* Anpassung der Margin-Werte */
    font-size: medium;
    text-align: left;
    /* Links ausrichten */
  }

  span {
    width: 0.7rem;
    height: 0.7rem;
    display: inline-block;
    margin-right: 5px;
    /* Abstand zwischen Span und Text */
  }

  #rot,
  #orange,
  #gelb,
  #gruen,
  #blau {
    vertical-align: middle;
    /* Ausrichtung in der Mitte */
  }

  #rot {
    background-color: red;
  }

  #blau {
    background-color: blue;
  }

  #gelb {
    background-color: yellow;
  }

  #gruen {
    background-color: green;
  }

  #orange {
    background-color: orange;
  }

  span {
    width: 0.7rem;
    height: 0.7rem;
    display: inline-block;
  }
}

    #bearbeitungsButton {
      background-color: white !important;
      position: absolute !important;
      top: 7.5rem !important;
      right: 0.5rem !important;
      z-index: 1000 !important;
      padding: 0.5rem !important;
      border-radius: 7px !important;
    }
  
    #bearbeitungsControl {
      background-color: white !important;
      position: absolute !important;
      top: 9rem !important;
      right: 2rem !important;
      z-index: 999 !important;
      padding: 1rem !important;
      border-radius: 7px !important;
      border: solid grey 1px;
      max-width: 16rem;
  
      button {
        width: 100%;
        padding-top: 2px;
        padding-bottom: 2px;
        margin-top: 3px;
        margin-bottom: 3px;
        font-size: medium;
        padding-right: 3px;
        padding-left: 3px;
      }
  
      .buttonOn {
        background-color: green;
        color: white;
      }
  
      .buttonOff {
        background-color: rgb(238, 238, 238);
        color: black;
      }
    }
</style>

<style lang="scss">
.leaflet-control-zoom{
    display: none;
}
</style>
